let configured = false;
let pixelId = "";

function installPixel(id) {
  if (!id || window.fbq) return;
  const fbq = function () { fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments); };
  fbq.push = fbq; fbq.loaded = true; fbq.version = "2.0"; fbq.queue = [];
  window.fbq = fbq;
  const script = document.createElement("script"); script.async = true; script.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(script);
  window.fbq("init", id);
}

export const meta = {
  async init() {
    if (configured) return pixelId;
    configured = true;
    try {
      const response = await fetch("/api/meta_config.php", { headers: { Accept: "application/json" } });
      const data = await response.json();
      pixelId = data.pixel_id || "";
      installPixel(pixelId);
    } catch (_) {}
    return pixelId;
  },
  trackPageView() { try { window.fbq?.("track", "PageView"); } catch (_) {} },
  trackViewContent() { try { window.fbq?.("track", "ViewContent", { content_name: "legacy_ease_funnel" }); } catch (_) {} },
  trackLead(eventId) {
    try {
      if (!eventId) return false;
      window.fbq?.("track", "Lead", { content_name: "legacy_ease", conversion: true }, { eventID: eventId });
      return Boolean(window.fbq);
    } catch (_) { return false; }
  },
};
